module.exports = "<svg viewBox=\"0 0 560 560\" xmlns=\"http://www.w3.org/2000/svg\"><title>plus</title><path d=\"M280 40C147.452 40 40 147.415 40 279.993c0 132.517 107.453 239.992 240 239.992 132.548 0 240-107.475 240-239.993C520 147.416 412.548 40 280 40zm75.007 224.993h-60v-60.008c0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15v60.007h-60c-8.28 0-15 6.713-15 15 0 8.28 6.72 15 15 15h60v60c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15v-60h60c8.28 0 15-6.72 15-15 0-8.287-6.72-15-15-15z\" fill=\"#4BC2B8\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./src/icons/plus.svg
// module id = 573
// module chunks = 0 1 2